import React from 'react';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ServicesSection from './ServicesSection';
import ContactSection from './ContactSection';
// import DownArrow from './DownArrow';

const MainContent: React.FC = () => {
  return (
    <div className="main-content">
      <HeroSection />
      {/* <AboutSection /> */}
      <ServicesSection />
      <ContactSection />
      {/* <div className="down-arrow-fixed">
        <DownArrow width={64} height={64} />
      </div> */}
    </div>
  );
};

export default MainContent; 